import './embed-header.scss'
import { observer } from 'mobx-react-lite'
import type { FC } from 'react'
import { cmsDataService } from '@/content/services/cms.data.service'
import { navigationService } from '@/content/services/navigation.service'
import { BackButton } from '@/features/orders/common/components/backButton/BackButton'

export const EmbedHeader: FC = observer(() => {
    const pageInfo = cmsDataService.getPageInfo()
    const { name, page } = pageInfo.get() ?? {}
    const currentSubPage = navigationService.getCurrentSubPage()

    if (page === 'ReviewTicket') {
        // ReviewTicket is a special case where we don't want to show the header
        // because that page is just the swap seats modal full-screen
        return null
    }

    // Hiding the title while the subpage loads and populates the name
    const hideTitle = ['Ticketing', 'FoodAndBeverage', 'GiftStore'].includes(page?.toString() ?? '')

    return (
        <>
            <div className="embed-header">
                <div className="embed-header__icon">
                    <BackButton buttonLabel="Back" currentSubPage={currentSubPage} />
                </div>
                <div className="embed-header__title">{hideTitle ? '' : name}</div>
                <div className="embed-header__icon" />
            </div>
            <div className="embed-header__space" />
        </>
    )
})
